// extracted by mini-css-extract-plugin
export var root = "footer-module--root--KpmE-";
export var column = "footer-module--column--C2DAr";
export var copyright = "footer-module--copyright--NzlVR";